export default __webpack_public_path__ + "static/media/event-9.7e007492.jpg";